export default __webpack_public_path__ + "static/media/face-4.dd7d022c.jpg";